// extracted by mini-css-extract-plugin
export default {"cameraContainer":"Camera_cameraContainer__MKFV2","containerController":"Camera_containerController__2SMie","btnCapture":"Camera_btnCapture__RSMan","title":"Camera_title__Hha2e"};